import React from 'react';
import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import NFTMarketplace from 'views/admin/marketplace';
import Profile from 'views/admin/profile';
import DataTables from 'views/admin/dataTables';
import RTL from 'views/admin/rtl';
// Auth Imports
import SignInCentered from 'views/auth/signIn';
import AllClient from 'views/admin/dataTables/components/AllClient';
import CreateClient from 'views/admin/dataTables/components/CreateClient';
import Developer from 'views/admin/dataTables/components/Developer';
import LoadRequest from 'views/admin/dataTables/components/LoadRequest';
import TransactionDetails from 'views/admin/dataTables/components/TransactionDetails';
import PayinReport from 'views/admin/dataTables/components/PayinReport';
import MyAccount from 'views/admin/dataTables/components/MyAccount';
import ClientLedger from 'views/admin/dataTables/components/ClientLedger';
import Settlement from 'views/admin/marketplace/settlement';

const routes = [
  {
    name: 'Main Dashboard',
    layout: '/198235201',
    path: '/dashboard',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
    name: 'Client Ledger',
    layout: '/198235201',
    path: '/payin_ledger',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <ClientLedger />,
  },
  {
    name: 'Settlements',
    layout: '/198235201',
    path: '/settlement_process',
    icon: (
      <Icon
        as={MdOutlineShoppingCart}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <NFTMarketplace tableData={[]}  />,
    secondary: true,
  },

  
 
  {
    name: 'All clients',
    layout: '/198235201',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    path: '/all_clients',
    component: <AllClient />,
  },
  {
    name: 'Create Client',
    layout: '/198235201',
    path: '/create_client',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <CreateClient />,
  },
  {
    name: 'Developer',
    layout: '/198235201',
    path: '/developer',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Developer />,
  },
  {
    name: 'Load Request',
    layout: '/198235201',
    path: '/load_request',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    component: <LoadRequest />,
  },
  {
    name: 'Pay-In',
    layout: '/198235201',
    path: '/payin_report',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <PayinReport />,
  },
  {
    name: 'Transaction Details',
    layout: '/198235201',
    path: '/transaction_query',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <TransactionDetails />,
  },
  {
    name: 'Pay-out',
    layout: '/198235201',
    path: '/payout',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <MyAccount />,
  },
  {
    name: 'Logout ',
    layout: '/198235201',
    path: '/198235201',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
  }
  
];



export default routes;
